<div class="general-info-card">
    <div class="vaccination-header">
        <div class="status-indicators">
            <span class="placement-name-indicator">
                {{ placementName || '-' }}
            </span>
            <span class="applicationType-indicator">
                {{ vaccination?.applicationType || '-' }}
            </span>
            <span class="age-indicator">
                Age: {{ vaccination?.age ?? 0 }} days
            </span>
        </div>
        <div class="date-time">
            {{ placement?.createdOn | date: 'yyyy-MM-dd' }} |
            {{ placement?.createdOn | date: 'HH:mm' }}
        </div>
    </div>

    <div class="vaccination-grid">
        <div class="grid-item">
            <div class="field-label">Vaccine Name:</div>
            <div class="field-value">
                {{ vaccination?.vaccinName || '-' }}
            </div>
        </div>
        <div class="grid-item">
            <div class="field-label">Supplier:</div>
            <div class="field-value">
                {{ vaccination?.supplierName || '-' }}
            </div>
        </div>

        <div class="grid-item">
            <div class="field-label">Birds Vaccinated:</div>
            <div class="field-value">
                {{ vaccination?.birdsVaccinated ?? 0 }}
            </div>
        </div>

        <!-- <div class="grid-item">
            <div class="field-label">Water Temperature:</div>
            <div class="field-value">
                {{ vaccination?.waterTemperature || '-' }} {{ temperatureUnit }}
            </div>
        </div> -->

        <div class="grid-item">
            <div class="field-label">Quantity:</div>
            <div class="field-value">
                {{ vaccination?.quantity ?? 0 }} Box(s)
            </div>
        </div>

        <div class="grid-item">
            <div class="field-label">Batch Number:</div>
            <div class="field-value">
                {{ vaccination?.batchNumber || '-' }}
            </div>
        </div>

        <div class="grid-item">
            <div class="field-label">Houses:</div>
            <div class="field-value">
                {{ vaccination?.farmHouseName || '-' }}
            </div>
        </div>
       
        <div class="grid-item">
            <div class="field-label">Expiry Date:</div>
            <div class="field-value">
                {{ vaccination?.expiryDate | date: 'yyyy-MM-dd' }}
            </div>
        </div>

        <!-- <div class="grid-item">
            <div class="field-label">Staff:</div>
            <div class="field-value">
                {{ vaccination?.staff || '-' }}
            </div>
        </div> -->

        <div class="vaccination-notes">
            <div class="field-label">Notes:</div>
            <div class="field-value">{{ vaccination?.notes }}</div>
        </div>
    </div>
</div>
